import React from 'react';
import { PropTypes } from 'prop-types';

import { formatDate } from '../../utility/dates';
import ConfirmableLink from '../shared/confirmable-link';

const ProviderIncentiveCostTable = ({ data }, { deleteIncentive, pickIncentiveCost }) => (
  <table>
    <thead>
      <tr>
        <th>Start Date</th>
        <th>End Date</th>
        <th>Service Specialty</th>
        <th>State</th>
        <th>Assigned Number of Providers</th>
        <th>Max Num of Providers</th>
        <th>Amount</th>
        <th />
      </tr>
    </thead>
    <tbody>
      { data.map(cost => (
        <tr key={cost.provider_incentive_cost_id}>
          <td>{formatDate(cost.start_date)}</td>
          <td>{formatDate(cost.end_date)}</td>
          <td>{cost.service_specialty_name}</td>
          <td>{cost.state_code}</td>
          <td>
            <a onClick={() => pickIncentiveCost(cost)} className="add">&nbsp;</a>&nbsp;
            {cost.max_number_providers ? cost.providers_count : 'N/A'}
          </td>
          <td>{cost.max_number_providers || 'N/A'}</td>
          <td>{cost.amount}</td>
          <td>
            <ConfirmableLink
              message="Are you sure you want to delete this?"
              onConfirmation={() => deleteIncentive(cost.provider_incentive_cost_id)}
            >
              Delete
            </ConfirmableLink>
          </td>
        </tr>
        ))
      }
    </tbody>
  </table>
);

const ProviderShape = PropTypes.shape({
  start_date:                 PropTypes.string,
  end_date:                   PropTypes.string,
  state_code:                 PropTypes.string,
  service_specialty_name:     PropTypes.string,
  max_number_providers:       PropTypes.number,
  providers_count:            PropTypes.number,
  amount:                     PropTypes.number,
  provider_incentive_cost_id: PropTypes.number
});

ProviderIncentiveCostTable.propTypes = {
  data: PropTypes.arrayOf(ProviderShape)
};

ProviderIncentiveCostTable.contextTypes = {
  pickIncentiveCost: PropTypes.func,
  deleteIncentive:   PropTypes.func
};

export default ProviderIncentiveCostTable;
